import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const MyContractsSkeleton: React.FC = () => (
  <div className="space-y-3">
    <Skeleton className="h-6 w-40" />
    <div className="space-y-2 rounded-md border p-3">
      {[0, 1, 2].map((i) => <Skeleton key={i} className="h-9 w-full" />)}
    </div>
  </div>
)

export default MyContractsSkeleton
